export default {
  partners (state) {
    return {
      ...state,
      storeName: 'partners'
    }
  }
}
